<template>

	<span>

		<span aria-hidden="true" :class="'icon-' + icon">

			<span
				v-for="(path, index) in paths"
				:key="index"
				:class="'path' + index"
			/>

			<slot />

		</span>

	</span>

</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "Icon",

	props: {
		icon: {
			type: String,
			required: true
		},

		paths: {
			type: Number,
			default: 0
		}
	},

	setup() {
		return {};
	}
});
</script>

<style lang="scss" scoped>

@font-face
{
	font-family: "Icons";
	src: url("/src/fonts/icons.woff2") format("woff2"),url("/src/fonts/icons.ttf") format("truetype");
	font-display: swap;
}

[class^="icon-"], [class*=" icon-"]
{
	font-family: "Icons" !important;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;

	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.icon {
	font-size: 100px;
	margin: 10px;
}

/* Icons */
.icon-arma4:before {
    content: "\e000";
}

.icon-audioengine:before {
    content: "\e001";
}

.icon-blender:before {
    content: "\e002";
}

.icon-coopscoop:before {
    content: "\e003";
}

.icon-cpp:before {
    content: "\e004";
}

.icon-csharp:before {
    content: "\e005";
}

.icon-cv:before {
    content: "\e006";
}

.icon-dayz:before {
    content: "\e007";
}

.icon-gallusengine:before {
    content: "\e008";
}

.icon-git:before {
    content: "\e009";
}

.icon-github:before {
    content: "\e00a";
}

.icon-gudenuffengine:before {
    content: "\e00b";
}

.icon-home:before {
    content: "\e00c";
}

.icon-insheepsclothing:before {
    content: "\e00d";
}

.icon-itch:before {
    content: "\e00e";
}

.icon-js:before {
    content: "\e00f";
}

.icon-linkedin:before {
    content: "\e010";
}

.icon-mail:before {
    content: "\e011";
}

.icon-msfs:before {
    content: "\e012";
}

.icon-msfs24:before {
    content: "\e013";
}

.icon-perforce:before {
    content: "\e014";
}

.icon-playstation:before {
    content: "\e015";
}

.icon-steam:before {
    content: "\e016";
}

.icon-unity:before {
    content: "\e017";
}

.icon-unreal:before {
    content: "\e018";
}

.icon-user:before {
    content: "\e019";
}

.icon-visual-studio:before {
    content: "\e01a";
}

.icon-visual-studio-code:before {
    content: "\e01a";
}

.icon-vr:before {
    content: "\e01b";
}

.icon-windows:before {
    content: "\e01c";
}

.icon-work:before {
    content: "\e01d";
}

.icon-xbox:before {
    content: "\e01e";
}

</style>